export class BilletHistoryModel {
    message: string = ""
    created_at: Date|string = ""

    constructor(b?:Partial<BilletHistoryModel>) {
        Object.assign(this, b)
    }
}
